import Format from '../common/Format';
import FormatCode from '../common/FormatCode';
import Common from '../common/Common';
import {
	cst_pay_unit_type_day,
	cst_pay_unit_type_month,
	cst_payment_request_status,
} from '../variables/codes_map';
const moment = require("moment");
export default class Definition {
    static qty_sum (data){
		var total = 0 
		for (var key in data) {
			switch(key){
				case "car_qty":
				case "light_truck_qty":
				case "truck_qty":
				case "other_car_qty":
					if(data[key]){
						total = total + parseInt(data[key])
					}

		
			}
		}

		// return  parseInt(data["car_qty"]) + parseInt(data["light_truck_qty"]) + parseInt(data["truck_qty"]) + parseInt(data["other_car_qty"]);   
		return total;
    }	
    static item (set,originalData){
		
		const data = (originalData instanceof Array)?
		(originalData):
		(Object.keys(originalData).reduce((acc, key)=>{
			if (originalData[key]===null){
				acc[key]=""
			} else {
				acc[key]=originalData[key]
			}
			return acc
		},{}))
			// console.log(set)
            switch(set){
			case '___JOIN_client_master':
				const customer_user = (data["customer_user"])||{
					customer_user_name:data["customer_user_name"],
					customer_user_tel:data["customer_user_tel"],
					customer_user_tel2:data["customer_user_tel2"],
				};
				const customer = (data["customer_user"]&&data["customer_user"]["customer"])||{
					customer_name:data['customer_name']
				};
				const customer_branch = (data["customer_user"]&&data["customer_user"]["customer_branch"])||{
					customer_branch_name:data['customer_branch_name']
				};

				return customer["customer_name"]+" "
					+customer_branch["customer_branch_name"]+"<br />"
					+customer_user["customer_user_name"]+"<br />"
					+(customer_user["customer_user_tel"] || "")+"<br />"
					+(customer_user["customer_user_tel2"] || "");

			case '___JOIN_subcontract_customer_information':
				const subcontract_customer_user = (data["subcontract_customer_user"])||{
					customer_user_name:data["subcontract_customer_user_name"],
					customer_user_tel:data["subcontract_customer_user_tel"],
					customer_user_tel2:data["subcontract_customer_user_tel2"],
				};
				const subcontract_customer = (data["subcontract_customer_user"]&&data["subcontract_customer_user"]["subcontract_customer"])||{					
					customer_name:data['subcontract_customer_name']
				};
				const subcontract_customer_branch = (data["subcontract_customer_user"]&&data["subcontract_customer_user"]["subcontract_customer_branch"])||{
					customer_branch_name:data['subcontract_customer_branch_name']
				};

				return (subcontract_customer["customer_name"]||"")+" "
					+(subcontract_customer_branch["customer_branch_name"]||"")+"<br />"
					+(subcontract_customer_user["customer_user_name"]||"")+"<br />"
					+(subcontract_customer_user["customer_user_tel"] ||"")+"<br />"
					+(subcontract_customer_user["customer_user_tel2"] || "");

			case '___JOIN_subcontract_customer_information_line':
				const subcontract_customer_user_line = (data["subcontract_customer_user"])||{
					customer_user_name:data["subcontract_customer_user_name"],
					customer_user_tel:data["subcontract_customer_user_tel"],
					customer_user_tel2:data["subcontract_customer_user_tel2"],
				};
				const subcontract_customer_line = (data["subcontract_customer_user"]&&data["subcontract_customer_user"]["subcontract_customer"])||{					
					customer_name:data['subcontract_customer_name']
				};
				const subcontract_customer_branch_line = (data["subcontract_customer_user"]&&data["subcontract_customer_user"]["subcontract_customer_branch"])||{
					customer_branch_name:data['subcontract_customer_branch_name']
				};

				return (subcontract_customer_line["customer_name"]||"")+" "
					+(subcontract_customer_branch_line["customer_branch_name"]||"")+" "
					+(subcontract_customer_user_line["customer_user_name"]||"")+"<br/>"
					+(subcontract_customer_user_line["customer_user_tel"]?("TEL " + subcontract_customer_user_line["customer_user_tel"]):"")+"<br/>"
					+(subcontract_customer_user_line["customer_user_tel2"]?("TEL " + subcontract_customer_user_line["customer_user_tel2"]):"");

			case '___JOIN_payment_bank':
				return (data["payment_type"] != 0) ? "" : data["payment_bank"]+" "+data["payment_bank_branch"]+"<br />"+FormatCode.decode("cst_payment_bank_account_type", data["payment_bank_account_type"])+"："+data["payment_bank_account_number"]+"<br />"+data["payment_bank_account_kana"];

			// case '___SUM_request_parking_qty':
			// 	return this.qty_sum(data)+"台";
			// break;
			case '___JOIN_request':
				return FormatCode.decode("request_type",data["request_type"])+"<br/>"+this.qty_sum(data)+"台";

			case '___JOIN_use_parking':
				if (data["request"]){
					return data["parking"]["parking_name"]+"（"+data["estimate"]["survey_capacity_qty"]+"台）"+"<br />"+data["parking"]["supplier"]["supplier_name"]+"<br />"+data["parking"]["supplier"]["supplier_tel"]+"<br/>"+`仕入賃料（月単価）：${(Format.comma_delimited(parseInt(data["estimate"]["survey_cost_parking_rent"]),"円"))}`;
				}else{
					return data["survey_parking_name"]+"（"+data["survey_capacity_qty"]+"台）"+"<br />"+data["supplier_name"]+"<br />"+data["supplier_tel"]+"<br/>"+`仕入賃料（月単価）：${(Format.comma_delimited(parseInt(data["survey_cost_parking_rent"]),"円"))}`;
				}

			case '___JOIN_quote_use_parking':
				if (data["request"]){
					return data["parking"]["parking_name"]+"（"+data["estimate"]["quote_capacity_qty"]+"台）"+"<br />"+data["parking"]["supplier"]["supplier_name"]+"<br />"+data["parking"]["supplier"]["supplier_tel"];
				}else{
					return data["survey_parking_name"]+"（"+data["quote_capacity_qty"]+"台）"+"<br />"+data["supplier_name"]+"<br />"+data["supplier_tel"];
				}

			case '___JOIN_request_natural_id':
				return data["request_natural_id"]+"<br />";

			case '___JOIN_deposit_history':
				return Format.format_date(data["INVOICE__deposit_date"])+" "+data["INVOICE__deposit_amt"]+"<br />";

			case '___JOIN_supplier':
				return data["SUPPLIER__supplier_name"]+"<br />"+data["ESTIMATE__supplier_user_name"]+"（"+data["SUPPLIER__supplier_tel"]+"）";

			case '___JOIN_available_date':
				return Format.format_date(data["SECURITY_DEPOSIT__available_start_date"])+" "+Format.format_date(data["SECURITY_DEPOSIT__available_end_date"]);
			case 'accounts_receivable_collection_flag':
				return Format.format_date(data["SECURITY_DEPOSIT__available_start_date"])+" "+Format.format_date(data["SECURITY_DEPOSIT__available_end_date"]);

			case '___JOIN_client_master_invoice':
				if (data["invoice_customer_user_name"]){
					return `<a target="_blank" href="/customer/detail/branch/${data["customer_branch_ulid"]}">${data["invoice_customer_name"]} ${data["invoice_customer_branch_name"]}</a>`
					+"<br />"
					+`<a target="_blank" href="/customer/detail/user/${data["invoice_customer_user_ulid"]}">${data["invoice_customer_user_name"]}（${data["invoice_customer_user_tel"]}）</a>`;
				} else {return""}
			case '___JOIN_client_master_deposit':
					return (data["customer_name"]||"")+"<br />"
					+(data["deposit_collect_customer_branch_flag"] ? data["customer_branch_name"] : "")
			case '___JOIN_invoice_document':
				return (data["latest_pdf_purchase_order_url"] ? (`<a target="_blank" href="/api/gcs_download/${data["latest_pdf_purchase_order_url"]}?d=発注書_${moment().format("YYYYMMDDHHmmss")}&extension=true">発注書</a><br />`) : "")
				+(data["latest_pdf_plotting_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["latest_pdf_plotting_url"]}">区画図面</a><br />`) : "")
				+(data["latest_pdf_quote_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["latest_pdf_quote_url"]}">確定見積書</a><br />`) : "")
				+(data["send_letter_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["send_letter_pdf_url"]}">送付状</a><br />`) : "")
				+(data["invoice_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["invoice_pdf_url"]}">請求書</a><br />`) : "")
				+(data["inhouse1_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["inhouse1_pdf_url"]}">B表内訳</a><br />`) : "")
				+(data["invoice_list_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["invoice_list_pdf_url"]}">一覧請求書</a><br />`) : "")
				+(data["contract_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["contract_pdf_url"]}">契約書</a><br />`) : "")
				+(data["change_send_letter_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["change_send_letter_pdf_url"]}">送付状（請求先変更済み）</a><br />`) : "")
				+(data["change_invoice_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["change_invoice_pdf_url"]}">請求書（請求先変更済み）</a><br />`) : "")
				+(data["change_contract_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["change_contract_pdf_url"]}">契約書（請求先変更済み）</a><br />`) : "")
				// +(data["inhouse1_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["inhouse1_pdf_url"]}">${data["inhouse1_pdf_url"]}</a><br />`) : "")
				// +(data["inhouse2_pdf_url"] ? (`<a target="_blank" href="https://drive.google.com/open?id=${data["inhouse2_pdf_url"]}">${data["inhouse2_pdf_url"]}</a><br />`) : "")

			case '___JOIN_project_information':
				if(data["project"]){
					return data["project"]["site_name"]+"<br />"+"（"+data["project"]["construction_number"]+"）";
				}else{
					return data["site_name"]+"<br />"+"（"+data["construction_number"]+"）";
				}

			case '___JOIN_project_information_with_site_customer':
				if(data["project"]){
					return data["project"]["site_name"]+"<br />"+"（"+data["project"]["construction_number"]+"）"+"<br />"+data["project"]["site_customer_user_name"]+"<br />"+data["project"]["site_customer_user_tel"];
				}else{
					return data["site_name"]+"<br />"+"（"+data["construction_number"]+"）"+"<br />"+data["site_customer_user_name"]+"<br />"+data["site_customer_user_tel"];
				}

			case '___JOIN_project_addr':
				if(data["project"]){
					return FormatCode.decode("prefecture",data["project"]["site_prefecture"])+" "+data["project"]["site_city"]+" "+data["project"]["site_address"];
				}else{
					return FormatCode.decode("prefecture",data["site_prefecture"])+" "+data["site_city"]+" "+data["site_address"];
				}

			case '___JOIN_project_information_addr':
				if(data["project"]){
					return data["project"]["site_name"]+"<br />"+"（"+data["project"]["construction_number"]+"）<br/>" +
					FormatCode.decode("prefecture",data["project"]["site_prefecture"])+" "+data["project"]["site_city"]+" "+data["project"]["site_address"];
				}else{
					return data["site_name"]+"<br />"+"（"+data["construction_number"]+"）<br/>" +
					FormatCode.decode("prefecture",data["site_prefecture"])+" "+data["site_city"]+" "+data["site_address"];
				}
			case '___JOIN_project_information_addr_with_site_customer':
				if(data["project"]){
					return data["project"]["site_name"]+"<br />"+"（"+data["project"]["construction_number"]+"）<br/>" +
					FormatCode.decode("prefecture",data["project"]["site_prefecture"])+" "+data["project"]["site_city"]+" "+data["project"]["site_address"]+
					"<br />"+data["project"]["site_customer_user_name"]+"<br />"+data["project"]["site_customer_user_tel"];
				}else{
					return data["site_name"]+"<br />"+"（"+data["construction_number"]+"）<br/>" +
					FormatCode.decode("prefecture",data["site_prefecture"])+" "+data["site_city"]+" "+data["site_address"]+
					"<br />"+data["site_customer_user_name"]+"<br />"+data["site_customer_user_tel"];
				}
			// case '___JOIN_invoice_process_status':
			// 	return Format.format_date(data["update_timestamp"])
			// 	+"<br />"+FormatCode.decode("cst_invoice_process_status",data["invoice_process_status"]);

			case '___JOIN_request_other_qty':
				return FormatCode.decode("request_type",data["request_type"])+"（"+data["request_other_qty"]+"個）";

			case '___JOIN_request_want_date':
				return Format.format_date(data["want_start_date"])+"〜"+" "+Format.format_date(data["want_end_date"]);

			case '___JOIN_survey_available_date':
				return Format.format_date(data["survey_available_start_date"])+"<br />"+"〜"+Format.format_date(data["survey_available_end_date"]);

			case '___JOIN_quote_available_date':
				return Format.format_date(data["quote_available_start_date"])+"<br />"+"〜"+Format.format_date(data["quote_available_end_date"]);

			case '___JOIN_payment_bank_name':
				return (data["payment_bank"] || '') +"<br />"+(data["payment_bank_branch"] || '');

			case '___JOIN_payment_bank_detail':
				return FormatCode.decode("cst_payment_bank_account_type", data["payment_bank_account_type"])+" "+data["payment_bank_account_number"];

			case '___SUM_other_total_amt':
				if(data.length > 0){
					return data&&data.reduce((acc, singleData)=>{
						acc += isNaN(Number(singleData['quote_cost_total_amt']))?0:Number(singleData['quote_cost_total_amt'])
						return acc
						}, 0)
				}else{
					return 0
				}

			case '___JOIN_want_other_date':
				return Format.format_date(data["request_other_start_date"])+"<br />"+"〜"+Format.format_date(data["request_other_end_date"]);

			case '___JOIN_parking':
				return data["parking_name"]+"<br />"+data["supplier_tel"];

			case '___JOIN_parking_addr':
				return FormatCode.decode("prefecture",data["parking_prefecture"])+" "+data["parking_city"]+"<br />"+data["parking_address"];
			case '___JOIN_survey_parking_addr':
				return FormatCode.decode("prefecture",data["survey_parking_prefecture"])+" "+data["survey_parking_city"]+"<br />"+data["survey_parking_address"];
			case '___JOIN_tree_request':
				return `<a target="_blank" href="/construction/parking/detail/${data["ulid"]}">${data["request_natural_id"]}</a> `+FormatCode.decode("request_type",data["request_type"])+"　"+Format.format_date(data["want_start_date"])+"～"+Format.format_date(data["want_end_date"])+"　ワゴン車（"+data["car_qty"]+"台）　軽トラック（"+data["light_truck_qty"]+"台）　2tトラック（"+data["truck_qty"]+"台）　その他（"+data["other_car_qty"] + "台）"

			case '___JOIN_tree_request_other':
				return ` <a target="_blank" href="/construction/other/detail/${data["ulid"]}">${data["request_natural_id"]}</a> ` + FormatCode.decode("request_type",data["request_type"])+"（"+data["request_other_qty"]+"個）"+Format.format_date(data["request_other_start_date"])+"～"+Format.format_date(data["request_other_end_date"])+"　"+(data["survey_status"]==9?"Closed（":"")+FormatCode.decode("cst_request_other_status",data["request_other_status"])+(data["survey_status"]==9?"）":"");

			case '___JOIN_tree_estimate':
				// console.log(data)
				if(data["estimate_status"] == "4"||data["estimate_status"] == "5"){
					return data["estimate_natural_id"]+"　"+FormatCode.decode("cst_estimate_status",data["estimate_status"])+"　"
					+data["survey_parking_name"]+"："
					+data["quote_capacity_qty"] + "台"
					+ "（"+data["supplier_tel"]+"）"
					+"　ワゴン車（" + Format.zero_one_to_symbol(data['survey_capacity_flag_car'] || 0) + "）"
					+"　軽トラック（" + Format.zero_one_to_symbol(data["survey_capacity_flag_light_truck"] || 0) + "）" 
					+ "　2tトラック（" + Format.zero_one_to_symbol(data["survey_capacity_flag_truck"] || 0) + "）"
					+"　その他（" + Format.zero_one_to_symbol(data["survey_capacity_flag_other"] || 0) + "）";
				}else{
					return data["estimate_natural_id"]+"　"+FormatCode.decode("cst_estimate_status",data["estimate_status"])+"　"
					+data["survey_parking_name"]+"："
					+data["survey_capacity_qty"] + "台"
					+ "（"+data["supplier_tel"]+"）"
					+"　ワゴン車（" + Format.zero_one_to_symbol(data["survey_capacity_flag_car"] || 0) + "）"
					+"　軽トラック（" + Format.zero_one_to_symbol(data["survey_capacity_flag_light_truck"] || 0) + "）" 
					+ "　2tトラック（" + Format.zero_one_to_symbol(data["survey_capacity_flag_truck"] || 0) + "）"
					+"　その他（" + Format.zero_one_to_symbol(data["survey_capacity_flag_other"] || 0) + "）";
				}

			case '___JOIN_request_update':
			case '___JOIN_estimate_update':
			case '___JOIN_parking_update':
			case '___JOIN_security_deposit_update':
			case '__JOIN_accounts_receivable_update':
			case '__JOIN_deposit_update':
				return Format.format_datetime(data["update_timestamp"])+"<br />"+(data["user_name"]);
			case '___JOIN_request_update_line':
				return "(更)"+Format.format_datetime_yymmdd(data["update_timestamp"])+" "+(data["user_name"]);
			case '___JOIN_request_cc_users':
				return data["CUSTOMER_USER__customer_user_name"]+"（"+data["CUSTOMER_USER__customer_user_email"]+"）";

			case '___JOIN_estimate_capacity':
				return '___JOIN_estimate_capacity';
			case '___SUM_all_amt':
				return (isNaN(Number(data['quote_cost_total_amt']))?0:Number(data['quote_cost_total_amt']))
				+ (isNaN(Number(data['quote_cost_other']))?0:Number(data['quote_cost_other']))
				+ (isNaN(Number(data['quote_cost_security_deposit_total_amt']))?0:Number(data['quote_cost_security_deposit_total_amt']))
				+ (isNaN(Number(data['quote_cost_adjustment']))?0:Number(data['quote_cost_adjustment']))
			case '___SUM_total_amt':
				if(data.length > 0){
					return data&&data.reduce((acc, singleData)=>{
						acc += isNaN(Number(this.item('___SUM_all_amt', singleData)))?0:Number(this.item('___SUM_all_amt', singleData))
						return acc
						}, 0)
				}else{
					return 0
				}
			case '___SUM_payment_amt':
				if(data.length > 0){
					return data.reduce((acc, singleData)=>{
						acc += isNaN(Number(singleData['payment_amt']))?0:Number(singleData['payment_amt'])
						// console.log('p',singleData['payment_amt'])
						// console.log('acc',acc)
						return acc
					}, 0)
	
				}else{
					return 0
				}
			case '__JOIN_customer_user_contact_information':
				return "<span style='white-space:nowrap;'>"+data["customer_user_tel"]+"</span><br />"+data["customer_user_email"];
			case '__JOIN_customer_user_contact_information_with_tel2':
				return "<span style='white-space:nowrap;'>"+data["customer_user_tel"]+"</span><br /><span style='white-space:nowrap;'>"+data["customer_user_tel2"]+"</span><br />"+data["customer_user_email"];
			case '___JOIN_parking_image':
				return data["parking_picture_url_thumbnail"] ? (
					data["parking_name"] + "<br />" + "写真あり"
				  ) : (
					data["parking_name"]
					) + "<br />" + "写真なし";
			case '___JOIN_project_information_estimate':
				return `${data['site_name']}<br/>（${data['construction_number']}）`
			case '___JOIN_client_estimate':
				return `${data['customer_name']} ${data['customer_branch_name']}<br/>${data['customer_user_name']}（${data['customer_user_tel']}）`
			case '___JOIN_payment_bank':
				return `${data['payment_bank']} ${data['payment_bank_branch']}<br/>${data['payment_bank_account_type']}：${data['payment_bank_account_number']}<br/>${data['payment_bank_account_kana']}`
			case '___JOIN_parking_capacity_flags':
				return `ワゴン車 ${Format.zero_one_to_symbol(data['capacity_flag_car'])}
					<br/>軽トラック ${Format.zero_one_to_symbol(data['capacity_flag_light_truck'])}
					<br/>2tトラック ${Format.zero_one_to_symbol(data['capacity_flag_truck'])}`
			case '___JOIN_parking_cost1':
				return `賃料 ${Format.comma_delimited(data['cost_parking_rent'],'円')}<br/>手数料${Format.comma_delimited(data['cost_commission'],'円')}`			
			case '___JOIN_parking_cost2':
				return `敷金 ${Format.comma_delimited(data['cost_security_deposit'],'円')}<br/>礼金 ${Format.comma_delimited(data['cost_key_money'],'円')}`
			case '___JOIN_parking_pay_unit_type':
				return `日割 ${Common.getValueFormDictArray(cst_pay_unit_type_day, data['pay_unit_type_day'])}
					<br/>通し ${Common.getValueFormDictArray(cst_pay_unit_type_month, data['pay_unit_type_month'])}`
			case '___JOIN_survey_supplier_imformation':
				const {
					supplier
				} = data
				return supplier&&`${supplier['supplier_name']}<br/> ${supplier['supplier_tel']}`
			case '___JOIN_survey_distance':
				// console.log(data)
				return (data.request_parking.site_distance_minute === null ?
					""
					:
					Format.disp_time(parseInt(data.request_parking.site_distance_meter),data.request_type)
					+ "<br/>"
					+ Format.comma_delimited(parseInt(data.request_parking.site_distance_meter),"m")
				)
			case '___JOIN_parking_addr_sub':
				return (data["parking_city"]||"")+" "+(data["parking_address"]||"");
			case '___JOIN_quote_available_date_payment':
				return "開始日（直近）：" + Format.format_date(data["quote_available_start_date"])+"<br />"+"終了日（最後）："+Format.format_date(data["quote_available_end_date"]);
			case '___JOIN_invoice_date_list':
				// console.log(data);
				return "仕入実施日：" + Format.format_date(data["invoice_payment_finish_date"])+"<br />"
					+"請求依頼日："+Format.format_date(data["invoice_request_date"])+"<br />"
					+"請求書生成日："+Format.format_date(data["invoice_process_pdf_date"])+"<br />"
					+"請求書変更日："+Format.format_date(data["invoice_process_pdf_lastupdate"])+"<br />"
					+"請求書発行日："+Format.format_date(data["invoice_closing_date"])+"<br />"
					+"支払期限日："+Format.format_date(data["payment_deadline"])+"<br />"
					+"請求完了日："+(data["invoice_process_status"]==4?Format.format_date(data["invoice_process_finish_date"]):"")+"<br />"
					+"請求ｷｬﾝｾﾙ日："+(data["invoice_process_status"]==5?Format.format_date(data["invoice_process_finish_date"]):"");
			case '___JOIN_payment_request_id':
				return (`<a target="_blank" href="https://drive.google.com/open?id=${data.latest_pdf_survey_url}">${data.estimate_natural_id}</a>`) 
					+ (`<br />`) + (FormatCode.decode("cst_payment_request_status",data.payment_request_status)).replace("仕入依頼差戻中","差戻")
			case '___JOIN_quote_cost_amt':
				return "賃料　"+Format.comma_delimited((data['survey_cost_parking_rent']||0),"円")
					+"</br>手数料　"+Format.comma_delimited((data['survey_cost_commission']||0),"円")
					+'</br>敷金　'+Format.comma_delimited((data['survey_cost_security_deposit']||0),"円")
					+' / 礼金　'+Format.comma_delimited((data['survey_cost_key_money']||0),"円")
			case '___JOIN_security_deposit_supplier':
				return `${data['survey_parking_name'] || ""}<br />${data['supplier_name'] || ""}<br/>${data['supplier_tel'] ? "TEL " + data['supplier_tel'] : ""}<br/>${data['supplier_fax'] ? "FAX " + data['supplier_fax'] : ""}`
			case '___JOIN_security_deposit_status':
				return `${FormatCode.decode("cst_security_deposit_status", data["security_deposit_status"])}<br />${data["security_deposit_status"] == 2 ? Format.format_date(data['security_deposit_collect_finish_date']) : ""}`
			case '___JOIN_security_deposit_contact_status':
				return `${FormatCode.decode("cst_security_deposit_contact_status", data["security_deposit_contact_status"])}
				<br />${data["security_deposit_contact_status"] == 1 
					? Format.format_date(data['security_deposit_prepare_contact_date']) 
					: data["security_deposit_contact_status"] == 2 
						? Format.format_date(data['security_deposit_contact_date']) : ""}`
			case '___JOIN_accounts_receivable_status':
				return `${FormatCode.decode("cst_accounts_receivable_status", data["accounts_receivable_status"])}<br />${data["accounts_receivable_status"] == 2 ? Format.format_date(data['receivable_collect_finish_date']) : ""}`
			case '___JOIN_invoice_bank':
				return `${data['invoice_bank_name']}</br>${data['invoice_bank_branch_name']}<br/>${FormatCode.decode("cst_payment_bank_account_type",data['invoice_bank_account_type'])}：${data['invoice_bank_account_number']}<br/>${data['invoice_bank_account_kana']}`
			case '___JOIN_payment_bank_code':
				return (data["bank_natural_id"] || '') +"<br />"+(data["bank_branch_natural_id"] || '');
			case '___JOIN_information_publish_date':
				return Format.format_datetime(data["start_date"])+"<br />"+"〜"+Format.format_datetime(data["end_date"]);
			case '___JOIN_invoice_change_master':
				return (data["change_invoice_name"] || '')
			// 2022/07/12 銀行口座名義
			case '___JOIN_supplier_bank_detail':
				return FormatCode.decode("cst_payment_bank_account_type", data["supplier_bank_account_type"])+"<br />"+data["supplier_bank_account_number"];
			case '___JOIN_supplier_bank':
				return data["supplier_bank"] + "<br />" + data["supplier_bank_branch"];
			// 2022/08/19 新受注管理
			case 'ESTIMATE_estimate_natural_id':
				return (data["register_type"] == 1 ? "(*)" : "" )+  data["estimate_natural_id"] + "<br />" + FormatCode.decode("cst_order_box_status", data["order_box_status"]);
			case '___JOIN_project_detail':
				let construction_number = data["construction_number"].length > 0? data["construction_number"] + "<br>":""
				// console.log(construction_number)
				return data["site_name"] + "<br />" + construction_number + FormatCode.decode("cst_prefecture", data["site_prefecture"]) + data["site_city"] + data["site_address"];
			case '___JOIN_project_detail_with_site_customer':
				let construction_number_ = data["construction_number"].length > 0? data["construction_number"] + "<br>":""
				// console.log(construction_number)
				return data["site_name"] + "<br />" + construction_number_ + FormatCode.decode("cst_prefecture", data["site_prefecture"]) + data["site_city"] + data["site_address"] + "<br />"+data["site_customer_user_name"]+"<br />"+data["site_customer_user_tel"];
			case '___JOIN_request_date':
				return data["quote_available_start_date"]
						? Format.format_date_yymmdd(data["quote_available_start_date"]) + "<br /> ～ " + Format.format_date_yymmdd(data["quote_available_end_date"])
					    : data["order_start_date"]
						? Format.format_date_yymmdd(data["order_start_date"]) + "<br /> ～ " + Format.format_date_yymmdd(data["order_end_date"])
						: Format.format_date_yymmdd(data["survey_available_start_date"]) + "<br /> ～ " + Format.format_date_yymmdd(data["survey_available_end_date"])
			case '___JOIN_parking_detail':
				return data["survey_parking_name"] +"（"+ data["survey_capacity_qty"] + "台）"
			// ステータス依頼内容 survey_status
			case '___JOIN_REQUEST_request_survey_status':
				return FormatCode.decode("request_type", data["request_type"]) + "<br/>" + this.qty_sum(data)+"台" + (data["auto_order_function_flag"] == 1 && data["auto_order_execution_flag"] == 1 ? "<br/><br/><font color=\"red\">自動発注</font>" : "");
			// 工事一覧の依頼情報領域:案件IDパス付
			case '___JOIN_REQUEST_ulid_and_box_status':
				return `<a target="_blank" href="/construction/parking/detail/${data["ulid"]}${data["box_status_param"]}">${data["request_natural_id"]}</a> `+FormatCode.decode("request_type",data["request_type"])+"　"+Format.format_date(data["want_start_date"])+"～"+Format.format_date(data["want_end_date"])+"　ワゴン車（"+data["car_qty"]+"台）　軽トラック（"+data["light_truck_qty"]+"台）　2tトラック（"+data["truck_qty"]+"台）　その他（"+data["other_car_qty"] + "台）"
			// 工事一覧の依頼情報領域（その他）:案件IDパス付
			case '___JOIN_REQUEST_ulid_other_and_box_status':
				return ` <a target="_blank" href="/construction/other/detail/${data["ulid"]}${data["box_status_param"]}">${data["request_natural_id"]}</a> ` + FormatCode.decode("request_type",data["request_type"])+"（"+data["request_other_qty"]+"個）"+Format.format_date(data["request_other_start_date"])+"～"+Format.format_date(data["request_other_end_date"])+"　"+(data["survey_status"]==9?"Closed（":"")+FormatCode.decode("cst_request_other_status",data["request_other_status"])+(data["survey_status"]==9?"）":"");
			// その他一覧　支払複数対応 
			case '___JOIN_payment_limit_date':
				let temp = ""
				data["payment_data"].length > 0 && data["payment_data"].map((pd)=>{
					temp += `<div>${Format.format_date(pd["payment_limit_date"])}</div>`
				})
				return temp;
			// その他一覧　その他依頼資料
			case '___JOIN_request_other_documents':
				return data["request_other_documents"] && data["request_other_documents"].length > 0 ? 
				(
					data["request_other_documents"].map(doc => {
						return `<a href="/api/gcs_download/${doc.file_path}?d=${encodeURIComponent(doc.file_name)}" target="_blank">${doc.name}</a>${doc.name !== "詳細"?` `:"<br />"}`;
					}).join("")
				)
				: "";
			}
    }
}
